<template>
  <div class="container">
    <div class="projector">{{$t('T_OPTION_LENS_SETTING')}}</div>
    <hr/>
    <div class="read-model-list">
      <div class="label ft">
        <label>1、{{$t('T_READ_CURRENT_LENS_LIST')}}</label>
      </div>
      <div class="list-but">
        <el-upload
        accept="json"
        action
        :on-change="fileChange"
        :auto-upload="false"
        :show-file-list="false"
      >
        <el-button type="button">{{$t('T_PRESS_HERE')}}</el-button>
      </el-upload>
      </div>
    </div>
    <hr/>
    <div class="updata-model-list">
      <div class="label ft">
        <label>2、{{$t('T_NEWEST_LENS_LIST_UPDATE')}}</label>
      </div>
      <div class="list-but">
       <el-upload
        accept="json"
        action
        :on-change="newDataChange"
        :auto-upload="false"
        :show-file-list="false"
        :disabled="showFlag?false:true"
      >
        <el-button type="button" :disabled="showFlag?false:true">{{$t('T_PRESS_HERE')}}</el-button>
      </el-upload>
      </div>
    </div>
    <hr/>
    <div class="make-esc">
      <div class="label">
        <label>3、{{$t('T_ESCS_SITUATION_MODIFY')}}</label>
      </div>
        <div class="lens-table" v-if="showFlag">
          <el-table
            :data="currentTableData"
            border
            style="width: 100%"
            height="700"
            :row-class-name="tableRowClassName"
            :default-sort = "{prop: 'id', order: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'}"
          >
            <el-table-column prop="id" :label="$t('T_MAINTENANCE_LENS_NAME')" width="120"></el-table-column>
            <el-table-column prop="vcode" :label="$t('T_MAINTENANCE_V_CODE')" width="170"></el-table-column>
            <el-table-column prop="discontinued" :label="$t('T_DISCONTINUED')" width="140">
              <template slot-scope="scope">
                <el-checkbox @change="userActionChange(scope.row)" v-model="scope.row.discontinued"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column label=""></el-table-column>
          </el-table>
        </div>
    </div>
    <hr/>
    <div class="read-model-list">
      <div class="label ft">
        <label>4、{{$t('T_OPTION_LENS_SETTING_OUTPUT')}}</label>
      </div>
      <div class="list-but">
        <el-button type="button" @click="saveFile()" :disabled="showFlag?false:true">{{$t('T_BUTTON_SAVE')}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { saveAs } from 'file-saver'
import Vue from 'vue'
export default {
  components: {},
  props: {},
  data () {
    return {
      search: '',
      dataKeyCol: '',
      inds: [],
      showFlag: false,
      lensData: null,
      currentTableData: [],
      userAction: []
    }
  },
  watch: {},
  computed: {
    modelDatabak () {
      return Vue.prototype.OptionLensSpecbak
    }
  },
  methods: {
    saveFile () {
      this.setDiscountedLens()
      this.lensData[0].isMainOLConfig = 1
      let data = JSON.stringify(this.lensData)
      var blob = new Blob([data], { type: '' })
      saveAs(blob, 'optionLensSpec.json')
    },
    fileChange (file) {
      // if (file.name !== 'optionLensSpec.json') {
      //   alert('upload error !')
      //   return
      // }
      this.currentTableData = []
      this.userAction = []
      let reader = new FileReader()
      reader.readAsText(file.raw)
      reader.onload = e => {
        this.lensData = JSON.parse(e.target.result)
        this.getCurrentTableData(this.lensData, false)
        this.showFlag = true
      }
    },
    userActionChange (val) {
      let isRepeat = this.userAction.findIndex(item => item.id === val.id)
      if (isRepeat === -1) {
        console.log('this.userAction', this.userAction)
        this.userAction.push(val)
      }
    },

    /**
     * 初始导入
     */
    getCurrentTableData (data, flag) {
      this.currentTableData.splice(0, this.currentTableData.length)
      for (let i = 0; i < data.length; i++) {
        let mod = this.currentTableData.findIndex(
          item => item.id === data[i].id
        )
        if (mod === -1) {
          var m = {}
          m.id = data[i].id
          m.name = data[i].name
          m.vcode = data[i].name.split(')')[1]
          m.discontinued = data[i].discontinued
          this.currentTableData.push(m)
        }
      }
    },

    /**
     * 导入比较
     */
    newDataChange (file) {
      // if (!this.lensData) {
      //   alert('modeldata为空')
      //   return
      // }
      let that = this
      let currentTableData = JSON.parse(JSON.stringify(that.currentTableData))
      this.currentTableData = []
      let newComData = []
      that.lensData = []
      let reader = new FileReader()
      reader.readAsText(file.raw)
      reader.onload = e => {
        that.lensData = JSON.parse(e.target.result)
        for (let i = 0; i < that.lensData.length; i++) {
          // let modCom = newComData.findIndex(item => item.id === newData[i].id)
          // if (modCom === -1) {
          let mod = currentTableData.findIndex(item => item.id === that.lensData[i].id)
          if (mod !== -1) {
            let modNew = newComData.findIndex(item => item.id === that.lensData[i].id)
            let isNotChange = (that.userAction.findIndex(item => item.id === that.lensData[i].id) === -1)
            if (modNew === -1) {
              if (isNotChange) {
                if (!currentTableData[mod].discontinued) {
                  currentTableData[mod].discontinued = that.lensData[i].discontinued
                }
              }
              newComData.push(currentTableData[mod])
            }
          } else {
            let modNew = newComData.findIndex(item => item.id === this.lensData[i].id)
            if (modNew === -1) {
              var m = {}
              m.id = this.lensData[i].id
              m.name = this.lensData[i].name
              m.vcode = this.lensData[i].name.split(')')[1]
              m.discontinued = false
              newComData.push(m)
              this.inds.push(this.lensData[i].id)
            }
          }
          // }
        }
        this.currentTableData.splice(0, this.currentTableData.length)
        this.currentTableData = newComData
      }
    },
    tableRowClassName ({ row }) {
      if (this.inds.indexOf(row.id) !== -1) {
        return 'newFlag'
      } else {
        return ''
      }
    },
    setDiscountedLens () {
      for (let i = 0; i < this.currentTableData.length; i++) {
        for (let j = 0; j < this.lensData.length; j++) {
          if (this.lensData[j].id === this.currentTableData[i].id) {
            this.lensData[j].discontinued = this.currentTableData[i].discontinued
          }
        }
      }
    }
  },
  created () {},
  mounted () {}
}
</script>
<style scoped>
.container {
  border-right: 2px solid #bdbdbd;
}

.projector {
  color: #000000;
  font-weight: bold;
  padding: 15px 20px;
}

.read-model-list, .updata-model-list, .make-esc {
  line-height: 45px;
}

.label {
  padding: 0px 25px;
}

table > tr {
  vertical-align: middle;
  overflow: scroll;
}
.option-text {
  margin-left: 30px;
  padding: 8px;
}
.tabs__item:nth-child(2) {
  padding-left: 0px;
}
.el-table__body-wrapper {
  overflow: auto;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/maintenanceTab/lensDataMainTab.vue